import { render } from "./KapibaraPhotoGallery.vue?vue&type=template&id=5ec9a30e"
import script from "./KapibaraPhotoGallery.vue?vue&type=script&lang=js"
export * from "./KapibaraPhotoGallery.vue?vue&type=script&lang=js"

import "./KapibaraPhotoGallery.vue?vue&type=style&index=0&id=5ec9a30e&lang=scss"

import exportComponent from "D:\\experement\\kapibara\\frontend\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__